import * as CardApplication from '@/src/experiences/card-application'
export default CardApplication.Screens.Highnote.VerifyPhoneOTPCardApplication
